import React from 'react';
import { styled } from '@linaria/react';

import '../../styles/warning.css';

const Warning = styled.button`
  background-color: var(--bb-warning-background);
  border-width: var(--bb-warning-border-width);
  border-style: var(--bb-warning-border-style);
  border-color: var(--bb-warning-border-color);
  border-radius: var(--bb-warning-border-radius);
  text-align: left;
  outline: none;
  padding-top: var(--bb-warning-padding-top);
  padding-right: var(--bb-warning-padding-right);
  padding-bottom: var(--bb-warning-padding-bottom);
  padding-left: var(--bb-warning-padding-left);
  margin-top: 16px;
  color: var(--bb-warning-color);
  font-family: inherit;
  font-size: var(--bb-warning-font-size);

  &:hover {
    cursor: pointer;
    background-color: var(--bb-warning-background--hover);
    color: var(--bb-warning-color--hover);
    border-color: var(--bb-warning-border-color--hover);
  }
`;

const WarningComponent = props => (
  <Warning
    type="button"
    {...props}
  />
);

export default WarningComponent;
